// extracted by mini-css-extract-plugin
module.exports = {"header":"Background_header___oLNb"};